import React from "react";
import "./../../UaeAttestation/UaeReq/UaeReq.css";

const MalaysiaReqMain = () => {
  return (
    <div className="uaeReqMainContainer">
      <div className="uaeReqMainContent">
        <h3>Requirement of Malaysia Attestation:</h3>
        <p>
          Certificate attestation for Malaysia visa is needed for several
          reasons such as student visa, residence visa, work visa, or for
          business aspects. It is a part of the evidence that shows that you are
          a legitimate person or company. It proves that your documents are true
          & can be allowed in the country.
        </p>
      </div>
      <div className="uaeReqMainContent">
        <h3>Total time-span to get Malaysia Certificate Attestation:</h3>
        <p>
          The time period required for certificate attestation for Malaysia
          depends upon several factors like the country you require the
          authentication for, or the types of documents, or the state you
          require it from. It will take around 15 days to a month to accomplish.
        </p>
      </div>
    </div>
  );
};

export default MalaysiaReqMain;
